import { useContext } from "react";
import { ParagraphText } from "../../../../Libraries";
import { LanguageContext } from "../../../../context/LanguageContext";
import { Box } from "@mui/material";

const AccountTableHeader = () => {
  const [I18n] = useContext(LanguageContext);
  return (
    <Box className="invoiceListTableHeader accountTableHeaderMain">
      <Box
        className={`invListTableHeaderCol fiveColumn textLeft sidebarOption`}
      >
        <ParagraphText
          className={"fontSize12 fontWeight500 newLightColor"}
          key={I18n.name}
        >
          {I18n.name}{" "}
        </ParagraphText>
      </Box>
      <Box className={`invListTableHeaderCol fiveColumn textLeft`}>
        <ParagraphText
          className={"fontSize12 fontWeight500 newLightColor"}
          key={I18n.number}
        >
          {I18n.number}{" "}
        </ParagraphText>
      </Box>
      <Box className={`invListTableHeaderCol fiveColumn textLeft`}>
        <ParagraphText
          className={"fontSize12 fontWeight500 newLightColor"}
          key={I18n.due_date}
        >
          {I18n.due_date}{" "}
        </ParagraphText>
      </Box>
      <Box className={`invListTableHeaderCol fiveColumn textRight`}>
        <ParagraphText
          className={"fontSize12 fontWeight500 newLightColor textRight"}
          key={I18n.balance}
        >
          {I18n.balance}{" "}
        </ParagraphText>
      </Box>
      <Box className={`invListTableHeaderCol fiveColumn textCenter`}>
        <ParagraphText
          className={"fontSize12 fontWeight500 newLightColor textCenter"}
          key={I18n.actions}
        >
          {I18n.actions}{" "}
        </ParagraphText>
      </Box>
    </Box>
  );
};

export default AccountTableHeader;
